import VehicleSelectDetailsCardExpansion from './VehicleSelectDetailsCardExpansion';

export default VehicleSelectDetailsCardExpansion;
